document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    if (header) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 35) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    const reviewsSlider = document.querySelector('.reviews-slider');
    if (reviewsSlider) {
        new Swiper(reviewsSlider, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                }
            },
        });
    }

    // Close offcanvas menu when clicking on a link (for mobile)
    const navLinks = document.querySelectorAll('.offcanvas .nav-link, .offcanvas .btn-registration');
    const offCanvasEl = document.getElementById('navbarOffcanvas');
    if (offCanvasEl && navLinks.length > 0) {
        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                const instance = bootstrap.Offcanvas.getInstance(offCanvasEl);
                if (instance) {
                    instance.hide();
                }
            });
        });
    }
});
